const chunkString = (value, size) => {
  if (typeof value !== 'string' || size <= 0) return [value];
  const chunks = [];
  for (let i = 0; i < value.length; i += size) {
    chunks.push(value.slice(i, i + size));
  }
  return chunks;
};

export default chunkString;
